module.exports = __webpack_public_path__ + "static/media/hand_and_egg.b40b4362.png";